import MyLocationIcon from "@mui/icons-material/MyLocation";
import { IconX, IconNavigation } from "../../../../shared/icons";
import styles from "./MapView.module.scss";

interface Props {
  mapRef: React.RefObject<HTMLDivElement>;
  mapsReady: boolean;
  showRecenter: boolean;
  onRecenter: () => void;
  routeActive: boolean;
  routeInfo: { distance: string; duration: string } | null;
  onCloseRoute: () => void;
  onOpenExternal: () => void;
}

const MapView = ({
  mapRef, mapsReady, showRecenter, onRecenter,
  routeActive, routeInfo, onCloseRoute, onOpenExternal,
}: Props) => (
  <div className={`${styles.wrap} ${routeActive ? styles.fullscreen : ""}`}>
    {!mapsReady && (
      <div className={styles.loading}><span className={styles.spinner} /></div>
    )}
    <div ref={mapRef} className={styles.canvas} />

    {showRecenter && mapsReady && !routeActive && (
      <button className={styles.recenter} onClick={onRecenter} aria-label="Recentrer" title="Ma position">
        <MyLocationIcon style={{ fontSize: 16 }} />
      </button>
    )}

    {routeActive && (
      <>
        <button className={styles.closeRoute} onClick={onCloseRoute} aria-label="Fermer l'itinéraire">
          <IconX size={16} />
        </button>
        {routeInfo && (
          <div className={styles.routeBanner}>
            <div className={styles.routeStats}>
              <IconNavigation size={14} />
              <span><strong>{routeInfo.duration}</strong> · {routeInfo.distance}</span>
            </div>
            <button className={styles.externalLink} onClick={onOpenExternal}>
              Ouvrir dans Google Maps
            </button>
          </div>
        )}
      </>
    )}
  </div>
);

export default MapView;